import { useState } from 'react';
import { googleSignIn } from '../utils/auth';

const LoginPage = ({ onLogin, onGoogleSuccess, onSwitch, country }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!email || !password) { setError("Please fill in all fields"); return; }
    onLogin({ email, password });  // <-- ADD password here!
  };

  return (
    <div className="auth-page">
      <div className="auth-left">
        <h1>Welcome Back</h1>
        <p>Sign in to access your portfolio, track investments, and discover new properties.</p>
        <ul className="auth-features">
          <li><i className="fas fa-check-circle"></i> Track your investments in real-time</li>
          <li><i className="fas fa-check-circle"></i> Receive monthly dividend payments</li>
          <li><i className="fas fa-check-circle"></i> Buy and sell shares on our marketplace</li>
          <li><i className="fas fa-check-circle"></i> Access exclusive property offerings</li>
        </ul>
      </div>
      <div className="auth-right">
        <div className="auth-card">
          <h2>Log In</h2>
          <p className="subtitle">Enter your credentials to access your account</p>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Email Address</label>
              <input type="email" placeholder="you@example.com" value={email} onChange={(e)=>setEmail(e.target.value)} />
            </div>
            <div className="form-group">
              <label>Password</label>
              <input type="password" placeholder="Enter your password" value={password} onChange={(e)=>setPassword(e.target.value)} />
            </div>
            {error && <div className="form-error" style={{marginBottom:"1rem"}}>{error}</div>}
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"1rem"}}>
              <label style={{display:"flex",alignItems:"center",gap:"0.5rem",fontSize:"0.9rem",cursor:"pointer"}}>
                <input type="checkbox" /> Remember me
              </label>
              <a href="#" style={{fontSize:"0.9rem",color:"var(--primary)",textDecoration:"none"}}>Forgot password?</a>
            </div>
            <button type="submit" className="btn btn-primary" style={{width:"100%",padding:"0.9rem"}}>Log In</button>
          </form>
          <div className="auth-divider">or continue with</div>
          <button className="social-btn" style={{marginBottom:"0.5rem"}} onClick={() => googleSignIn(onGoogleSuccess, country || "US")}>
            <i className="fab fa-google" style={{color:"#DB4437"}}></i> Continue with Google
          </button>
          <button className="social-btn">
            <i className="fab fa-apple" style={{color:"#000"}}></i> Continue with Apple
          </button>
          <p style={{textAlign:"center",marginTop:"1.5rem",color:"var(--text-light)",fontSize:"0.9rem"}}>
            Don't have an account? <a href="#" onClick={(e)=>{e.preventDefault();onSwitch();}} style={{color:"var(--primary)",fontWeight:600,textDecoration:"none"}}>Sign up</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
